// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCNHmePxQGJUS-wsfk1YMSXIr-dBqzqRjk",
    authDomain: "programminghero-assignment-10.firebaseapp.com",
    projectId: "programminghero-assignment-10",
    storageBucket: "programminghero-assignment-10.appspot.com",
    messagingSenderId: "415334203129",
    appId: "1:415334203129:web:4d49dd72e9b260e3d6ac28"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default auth;